import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import QrCodeViewer from './QRCodeViewer';

interface QrCodeModalProps {
  show: boolean;
  onHide: () => void;
  value: string;
  height: number;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ show, onHide, value, height }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>QR Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <QrCodeViewer value={value} height={height} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QrCodeModal;
